import { inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { map, switchMap, take } from 'rxjs/operators'
import { TeamMetadata } from '@pages/team/models/team.models'
import { selectSelectionTeams } from '@features/selections/store/selectors/selections.selectors'
import { completeWhen } from '@mediacoach/ui'
import { Observable } from 'rxjs'
import { Competition, Season } from '@core/models/season-competition.models'
import { selectFavCurrentSeasonCompetitionWithFavTeamId } from '@features/seasons/state/selectors/seasons.selectors'

@Injectable({ providedIn: 'root' })
export class TeamHandler {
  private readonly _store: Store = inject(Store)

  defaultTeam$: Observable<{ season: Season; competition: Competition; teamId: string }> = this._store.pipe(
    selectFavCurrentSeasonCompetitionWithFavTeamId('TeamSpace'),
    take(1),
    switchMap((data: TeamMetadata) =>
      this._store.select(selectSelectionTeams).pipe(
        completeWhen((teams) => !!teams?.length),
        map((teams) => {
          const team = teams.find((t) => t.id === data?.teamId)
          return {
            ...data,
            teamId: team?.id ?? teams?.[0]?.id
          }
        })
      )
    )
  )
}
